module.exports = __webpack_public_path__ + "img/feature-orders.c5f1219f.png";